<sol-layout [layout]="layout$()" role="group">
  @for (button of buttons$(); track button.id ?? index; let index = $index) {
    <div
      class="sol-button-group-button"
      [class.sol-button-group-button-selected]="button.selected"
      [class.sol-button-group-button-small]="size$() === 'small'"
      [class.sol-button-group-button-icon]="button.icon !== undefined"
      [class.sol-button-group-button-no-text]="button.name.isEmpty()"
      [class.sol-button-group-button-disabled]="button.disabled"
      (click)="onSelect($event, button.id)"
    >
      @if (button.icon) {
        <sol-icon [name]="button.icon" />
      }
      {{ button.name | translate }}
    </div>
  }
</sol-layout>
